import Super from './single-select-review';
import classic from 'ember-classic-decorator';

@classic
export default class SharedQuestionnaireMultiSelectReview extends Super {}
